import { useQuery, UseQueryOptions } from 'react-query';

import { getFacebookAccounts } from '~/api/routes/auth/user';
import { useAuthSelector } from '~/theseus/containers/Auth';

type Account = { id: string; name: string };

type UseAccountsQueryOptions<TError, TData> = UseQueryOptions<Account[], TError, TData>;
export function useAccountsQuery<TError = unknown, TData = Account[]>(options: Omit<UseAccountsQueryOptions<TError, TData>, 'enabled'> = {}) {
  const accessToken = useAuthSelector(state => state.context.authToken);

  return useQuery(
    ['accounts', accessToken],
    () => getFacebookAccounts(accessToken as string),
    {
      enabled: !!accessToken,
      ...options,
    },
  );
}
